import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InstitutionalRealEstateDevelopment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30858" id="the-vantage-point" ref={ref} className="relative h-screen w-full overflow-hidden bg-background text-foreground dark">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/ny_skyline_architecture_hero.png" alt="Architectural Optimization Backdrop" className="h-full w-full object-cover object-center grayscale opacity-40" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/60 to-background" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-10 hidden md:block">
        <div className="container mx-auto h-full border-x border-primary/10">
          <div className="grid h-full grid-cols-4">
            <div className="border-r border-primary/10" />
            <div className="border-r border-primary/10" />
            <div className="border-r border-primary/10" />
            {}
          </div>
        </div>
      </div>

      {}
      <div className="relative z-20 flex h-full flex-col justify-center px-6 md:px-12">
        <div className="container mx-auto flex h-full flex-col justify-center">
          {}
          <div className="flex flex-col items-center justify-center text-center md:items-start md:text-left">
            <h1 className="flex flex-col font-sans font-bold tracking-tighter leading-[0.85]">
              {}
              <span className={`block text-5xl sm:text-7xl md:text-8xl lg:text-9xl text-transparent transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
              WebkitTextStroke: "1px rgba(0, 255, 255, 0.3)"
            }}>
                OPTIMIZING THE
              </span>
              
              {}
              <span className={`block text-4xl sm:text-6xl md:text-7xl lg:text-8xl bg-gradient-to-br from-white to-[hsl(215,30%,40%)] bg-clip-text text-transparent mt-2 md:mt-0 transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
                CORE OF
                <br className="md:hidden" /> ENTERPRISE
              </span>
            </h1>
          </div>

          {}
          <div className="absolute bottom-12 left-0 w-full px-6 md:bottom-16 md:px-12">
            <div className="container mx-auto flex flex-col items-center justify-between gap-8 md:flex-row md:items-end">
              
              {}
              <div className={`max-w-[600px] transition-all duration-1000 delay-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
                <p className="border-l-2 border-primary/40 pl-4 font-sans text-lg font-light leading-relaxed text-muted-foreground md:text-xl">
                  Century Pointe Holdings specializes in technological optimization and strategic advisory, providing technical oversight to streamline digital workflows and internal infrastructures.
                </p>
              </div>

              {}
              <div className={`flex flex-col items-center gap-2 transition-all duration-1000 delay-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
                <span className="text-xs font-mono tracking-widest text-primary/60 uppercase">
                  Initialize
                </span>
                <Link to="#" className="flex h-12 w-12 animate-bounce items-center justify-center rounded-sm border border-primary/20 bg-primary/5 text-primary backdrop-blur-sm transition-all hover:bg-primary/20 hover:border-primary/40 hover:shadow-[0_0_20px_rgba(0,255,255,0.2)]" aria-label="Scroll to next section">
                  <ChevronDown className="h-5 w-5" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}